import { render } from "./myaccount.vue?vue&type=template&id=335ce02a&scoped=true"
import script from "./myaccount.vue?vue&type=script&lang=js"
export * from "./myaccount.vue?vue&type=script&lang=js"

import "./myaccount.vue?vue&type=style&index=0&id=335ce02a&scoped=true&lang=less"

import exportComponent from "D:\\Git仓库\\象新力官网\\html_xxldx_xxlx_xxlg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-335ce02a"]])

export default __exports__